<aside class="l-sidebar l-flex l-column scroller mCustomScrollbar _mCS_3">
  <img class="off-mobile sidebar-logo" src="../../assets/icons/logo.svg" alt="Artisan Sonics" />

  <!-- user panel (start) -->
  <div class="userPanel">
    <i class="userPanel-icon icon-female" *ngIf="pat.ID != 'default'">
      <span class="l-flex t-boxMargin menstural-fields-set">
        <button
          class="btn-user_data"
          aria-label="user data"
          (click)="showPatD()"
          matTooltip="Open Patient Details"
          [ngClass]="
            !patservice.getPat().Birth && (es.ExamType == 'NT' || es.ExamType == '1st')
              ? 'is-invalid'
              : ''
          "
        ></button>
        <div class="t-validation-message">
          <span>Add Birth day by clicking here</span>
        </div>
      </span>
    </i>

    <div class="userPanel-userName" *ngIf="pat.ID != 'default'">{{ pat.First }} {{ pat.Last }}</div>

    <dl class="l-table userPanel-userInfo" *ngIf="pat.ID != 'default'">
      <div class="l-row">
        <dt class="l-td-m">ID Number</dt>
        <dd class="l-td-m">{{ pat.ID }}</dd>
      </div>
      <div class="l-row">
        <dt class="l-td-m">Age</dt>
        <dd class="l-td-m">{{ patservice.getAgeMo() }}</dd>
      </div>
    </dl>

    <div class="userPanel-controls">
      <a
        (click)="bookmark()"
        class="userPanel-controls-item icon-files"
        [ngClass]="isBookmark ? 'saved' : ''"
        aria-label="files"
        matTooltip="Show Previous Exams in a Window"
      ></a>
      <a
        (click)="go('/exams')"
        class="userPanel-controls-item icon-exit"
        aria-label="exit"
        matTooltip="Close Exam and Open Patient History"
      ></a>
    </div>
  </div>
  <!-- user panel (end) -->

  <!-- main nav (start) -->
  <nav class="mainNav l-fg1">
    <ul class="mainNav-list">
      <li class="mainNav-item" (click)="setPage('Introduction')">
        <span class="mainNav-link" [ngClass]="currentPage == 'Introduction' ? 'is-active' : ''">
          {{ "exam.type.Eyes." + es.ExamType | translate }} Findings
        </span>
      </li>
    </ul>
  </nav>
  <!-- main nav (end) -->

  <app-docpanel [disableSiteSwitch]="true"></app-docpanel>
</aside>
